import '../../assets/styles/css/particles/title.css'

function Title(props) {
  return <h1 className='page-title'>{props.text}</h1>
}

export default Title
